import { useCallback, useState } from "react";

interface SelectorIdleHint {
  getHintIndex: (position: number) => number | undefined;
  markEngaged: () => void;
}

/**
 * Keeps the selector's onboarding hint separate from its selection state.
 *
 * Once a user interacts, the hint stays dismissed even if they later clear every
 * selection: by then the hint has already done its job.
 */
export const useSelectorIdleHint = (): SelectorIdleHint => {
  const [hasEngaged, setHasEngaged] = useState(false);

  const markEngaged = useCallback(() => {
    setHasEngaged(true);
  }, []);

  const getHintIndex = useCallback((position: number) => (hasEngaged ? undefined : position), [hasEngaged]);

  return { getHintIndex, markEngaged };
};
